import { MenuItem, Select, TextField } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import styles from './RadioButton.module.css';

const gainingSpaceListExpansion = [
    { value: 'improve1mm', label: 'Improve 1mm' },
    { value: 'improve2mm', label: 'Improve 2mm' },
    { value: 'improve3mm', label: 'Improve 3mm' },
    { value: 'improve4mm', label: 'Improve 4mm' },
    { value: 'improve5mm', label: 'Improve 5mm' },
];

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(3),
    },
}));

export default function RadioButton(props) {
    const classes = useStyles();
    const [extractionConcat, setExtractionConcat] = useState(props.extractionConcat),
        [expansionConcat, setExpansionConcat] = useState(props.expansionConcat);

    useEffect(() => {
        if (props.handleExtractionConcat && !props.disabled) props.handleExtractionConcat(extractionConcat);
    }, [extractionConcat]);

    useEffect(() => {
        if (props.handleExapantionConcat && !props.disabled) props.handleExapantionConcat(expansionConcat);
    }, [expansionConcat]);

    return (
        <FormControl className={styles.radioFieldset}>
            {props.label && <FormLabel className={styles.radioLabel}>{props.label}</FormLabel>}
            <RadioGroup
                className={styles.radioGroup}
                aria-label={props.ariaLabel}
                onChange={!props.disabled && props.handleChange}
                name={props.name}
                value={props.value}
            >
                <div className={styles.radioButtons} style={props.style}>
                    {props.radios.map((i, index) => (
                        <FormControlLabel value={i.value} control={<Radio />} label={i.label} key={i.value} />
                    ))}
                </div>
                {props.parent_name === 'extraction' && props.value == 'primary' && (
                    <div className={styles.toggleInput}>
                        <TextField
                            id="extraction_input"
                            placeholder="Additional Data"
                            className={classes.textField}
                            margin="normal"
                            onBlur={({ target }) => !props.disabled && setExtractionConcat(target.value)}
                            defaultValue={extractionConcat}
                        />
                    </div>
                )}
                {props.parent_name === 'expansion' && (props.value == 'primary' || props.value == 'secondary') && (
                    <div className={styles.toggleInput}>
                        <Select
                            displayEmpty
                            onChange={({ target }) => !props.disabled && setExpansionConcat(target.value)}
                            value={expansionConcat}
                        >
                            <MenuItem disabled>Select Option</MenuItem>
                            {gainingSpaceListExpansion.map((v) => (
                                <MenuItem value={v.value} key={v.value}>
                                    {v.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                )}
            </RadioGroup>
        </FormControl>
    );
}
